/**
 * TRowePrice environment URLs
 */
export const TRP_DOMAINS = {
    LOCAL: 'http://localhost.troweprice.com',
    DEV: 'https://wwwdev.troweprice.com',
    SIT: 'https://wwwsit.troweprice.com',
    STAGE: 'https://wwwstage.troweprice.com',
    PROD: 'https://troweprice.com',
};
//# sourceMappingURL=trp.js.map